import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { KNWarningIcon } from 'components/KNIcon/KNIcon'
import { KNEditIcon } from 'components/KNIcon/KNMaterialIcon'
import useDialog from 'global/hooks/useDialog'
import { type ReactElement, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import type { TripData } from 'screens/TripDashboard/TripDashboard.types'
import ProReferenceDialog from 'screens/TripDetails/ProReferenceDialog'
import type { CodeReference, LegData } from './TripDetails.types'

export interface ProReferenceProps {
  trip: TripData
  leg: LegData
  weblinkToken?: string
}

const ProReference = ({ trip, leg, weblinkToken }: ProReferenceProps): ReactElement => {
  const [proReference, setProReference] = useState<CodeReference>()
  const proEditDialog = useDialog<typeof ProReferenceDialog>()
  const { t } = useTranslation()

  useEffect(() => {
    setProReference(leg.attributes.shipmentReferences.find(item => item.code === 'AAK'))
  }, [leg])

  return (
    <Stack direction="row">
      <Typography variant="p3" color="primary.main" p={'0.2rem'}>PRO: </Typography>
      <Stack direction="row" spacing={1} onClick={proEditDialog.handleOpen}
        sx={{
          '& .hover-icon': {
            opacity: 0,
            transition: 'opacity 0.3s ease',
          },
          '&:hover .hover-icon': {
            opacity: 1,
          },
        }}>
        <Stack
          direction="row"
          spacing={1}
          onClick={proEditDialog.handleOpen}
          sx={{
            padding: '0.2rem',
            borderRadius: 1,
            '&:hover': {
              backgroundColor: 'darkblue.5',
            },
          }}
        >
          {proReference?.value !== '' ?
            (
              <Typography variant="p4" color="primary.main">{proReference?.value}</Typography>
            ) : (
              <>
                <KNWarningIcon color="error" fontSize="small" />
                <Typography variant="p4" color="primary.light">
                  {t('screens.cs.trip_details.pro.pro_missing')}
                </Typography>
              </>
            )
          } </Stack>
        <KNEditIcon className="hover-icon" color="primary" fontSize="small" />
      </Stack>
      <ProReferenceDialog
        payload={{ trip, leg, weblinkToken }}
        open={proEditDialog.isOpen}
        onAction={proEditDialog.handleAction}
        onClose={proEditDialog.handleClose}
      />
    </Stack>
  )
}

export default ProReference
